import { render, staticRenderFns } from "./DeclarationStatementBooksComponent.vue?vue&type=template&id=73c677a3&scoped=true&"
import script from "./DeclarationStatementBooksComponent.vue?vue&type=script&lang=js&"
export * from "./DeclarationStatementBooksComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationStatementBooksComponent.vue?vue&type=style&index=0&id=73c677a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c677a3",
  null
  
)

component.options.__file = "DeclarationStatementBooksComponent.vue"
export default component.exports